import { apiService } from "./../../app.service";

export const settingApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    updateAlertEmail: builder.mutation({
      query: (data) => ({
        url: "/user/update-alert-email/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["alertEmail"],
    }),
    getAlertEmail: builder.query({
      query: () => ({
        url: "/user/alert-email/",
      }),
      providesTags: ["alertEmail"],
    }),
    getAlertSMS: builder.query({
      query: () => ({
        url: "/user/sms",
      }),
      providesTags: ["alertSMS"],
    }),
    updateAlertSMS: builder.mutation({
      query: (data) => ({
        url: "/user/update-sms",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["alertSMS"],
    }),
    updateCheckDueTime: builder.mutation({
      query: ({ type, data }) => ({
        url: `/user/checklists/type/${type}/due-time`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["checklistDueTime"],
    }),
    getCheckDueTime: builder.query({
      query: (type) => ({
        url: `/user/checklists/type/${type}/due-time`,
      }),
      providesTags: ["checklistDueTime"],
    }),
    updateIncidentDueTime: builder.mutation({
      query: (data) => ({
        url: `/user/incidents/due-time`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["incidentDueTime"],
    }),
    getIncidentDueTime: builder.query({
      query: () => ({
        url: `/user/incidents/due-time`,
      }),
      providesTags: ["incidentDueTime"],
    }),
    updateTimezone: builder.mutation({
      query: (data) => ({
        url: "/user/restaurant/update-timezone",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["timezone"],
    }),
    getTimezone: builder.query({
      query: () => ({
        url: "/user/restaurant/timezone",
      }),
      providesTags: ["timezone"],
    }),
    
    // ✅ YEH DO NAYE ENDPOINTS ADD KARO
    getChecklistVisibility: builder.query({
      query: () => ({
        url: "/user/checklists/visibility",
      }),
      providesTags: ["checklistVisibility"],
    }),
    
    updateChecklistVisibility: builder.mutation({
      query: (data) => ({
        url: "/user/checklists/visibility",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["checklistVisibility"],
    }),

       // ✅ MONTHLY DUE TIME ENDPOINTS - YEH ADD KARO
    getMonthlyDueTime: builder.query({
      query: () => ({
        url: "/user/restaurant/due-time/monthly",
      }),
      providesTags: ["monthlyDueTime"],
    }),
    
    updateMonthlyDueTime: builder.mutation({
      query: (data) => ({
        url: "/user/restaurant/due-time/monthly",
        method: "PUT",
        body: data,  // data should be { dueTime: ["09:00"] }
      }),
      invalidatesTags: ["monthlyDueTime"],
    }),
    fetchChecklistSettings: builder.query({
      query: () => ({
        url: "/user/restaurant/checklist-settings", // Adjust URL as per your backend
      }),
      providesTags: ["ChecklistSettings"],
    }),
  }),
});

// ✅ EXPORTS MEIN YEH DO HOOKS ADD KARO
export const {
  useUpdateAlertEmailMutation,
  useGetAlertEmailQuery,
  useGetAlertSMSQuery,
  useUpdateAlertSMSMutation,
  useUpdateCheckDueTimeMutation,
  useUpdateIncidentDueTimeMutation,
  useGetCheckDueTimeQuery,
  useGetIncidentDueTimeQuery,
  useUpdateTimezoneMutation,
  useGetTimezoneQuery,
  useGetChecklistVisibilityQuery,      // ✅ YEH ADD KARO
  useUpdateChecklistVisibilityMutation, // ✅ YEH ADD KARO
  useGetMonthlyDueTimeQuery,        // ✅ YEH ADD KARO
  useUpdateMonthlyDueTimeMutation,
  useFetchChecklistSettingsQuery,
} = settingApi;